export function setTabIndex(name: string, index: string) {
  const element = Array.from(document.getElementsByClassName(name));
  if (element.length > 0) {
    element.forEach((e) => e.setAttribute("tabindex", index));
  }
}

export const PHONE_INPUT_CLASSNAME = "selected-flag" 
export const PHONE_INPUT_TABINDEX = "2"